import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex shadow-[0_-4px_20px_rgba(0,0,0,0.15)]" data-id="element-266">
      <a href="tel:517-220-0621" className="flex-1 bg-charcoal text-white flex items-center justify-center gap-2 py-4 font-bold uppercase tracking-wide text-sm active:bg-ink transition-colors" data-id="element-267">
        <Phone className="w-4 h-4" data-id="element-268" />
        Call Now
      </a>
      <Link to="/free-trial" className="flex-1 bg-storm-red text-white flex items-center justify-center py-4 font-display text-lg tracking-wide uppercase active:bg-storm-red-dark transition-colors" data-id="element-269">
        Claim Free Week
      </Link>
    </div>;
}